namespace $.$$ {
	$mol_style_define( $shm_knowledge_manual, {
		Text_page: {
			Title: { alignItems: 'center', padding: 0, minWidth: 0 },
		},
		Document_title: { padding: $mol_gap.text, flex: { shrink: 1 }, minWidth: 0 },
		Edit_toggle: { flex: { shrink: 0 } },
		Project_icon: { flex: { shrink: 0 }, opacity: .5 },
		Common_icon: { flex: { shrink: 0 }, opacity: .5 },
		Editor: { flex: { basis: '40rem', grow: 1, shrink: 0 } },
	} )
}
